<template>
  <div class="progress-card">
    <!-- main -->
    <!-- 待跟进/已跟进 -->
    <div v-if="tabsActive == -1 || tabsActive == 0">
      <person-card
        v-if="tabsActive !== 4"
        :content="item"
        :index="index + 1"
        :type="tabsActive === -1 ? 0 : 1"
        @onClick="toggle"
        :noDisposeTime="noDisposeTime"
      />
      <person-card
        v-else
        :content="item"
        :index="index + 1"
        :type="tabsActive === -1 ? 0 : 1"
      />
    </div>

    <!-- 已到访 -->

    <div
      v-if="tabsActive === 1"
      class="list"
      @click="
        toggle({
          id: item.id,
          type: 1,
        })
      "
    >
      <div class="infor" :class="{ if_expired: item.status === 5 }">
        <span>{{ index + 1 }}</span>
        <span class="person_name">{{ item.presentee }}</span>
        <span>
          <img
            src="../../../../../../common/images/recommend/sex_nan_select.png"
            v-if="!item.gender"
          />
          <img
            src="../../../../../../common/images/recommend/sex_nv_select.png"
            v-else
          />
        </span>
        <span>{{ item.contactNumber }}</span>

        <span>{{ item.createDate }}</span>
      </div>
    </div>

    <!-- 已认购 -->
    <div
      v-if="tabsActive === 3"
      class="list"
      @click="
        toggle({
          id: item.id,
          type: 1,
        })
      "
    >
      <div class="infor">
        <span>{{ index + 1 }}</span>
        <span class="person_name">{{ item.presentee }}</span>
        <span>
          <img
            src="../../../../../../common/images/recommend/sex_nan_select.png"
            v-if="!item.gender"
          />
          <img
            src="../../../../../../common/images/recommend/sex_nv_select.png"
            v-else
          />
        </span>
        <span>{{ item.recUserMobile }}</span>

        <span>{{ item.subscribeTime || "" }}</span>
      </div>
    </div>

    <!-- 已签约 -->
    <div
      v-if="tabsActive === 2"
      class="list"
      @click="
        toggle({
          id: item.id,
          type: 1,
        })
      "
    >
      <div class="infor">
        <span>{{ index + 1 }}</span>
        <span class="person_name">{{ item.presentee }}</span>
        <span>
          <img
            src="../../../../../../common/images/recommend/sex_nan_select.png"
            v-if="!item.gender"
          />
          <img
            src="../../../../../../common/images/recommend/sex_nv_select.png"
            v-else
          />
        </span>
        <span>{{ item.contactNumber }}</span>

        <span>{{
          item.subscribeTime ? item.subscribeTime : item.signDate
        }}</span>
      </div>
    </div>

    <!-- 已失效 -->

    <div
      v-if="tabsActive === 4"
      class="list"
      @click="
        toggle({
          id: item.id,
          type: 1,
        })
      "
    >
      <div class="infor" :class="{ if_expired: item.status === 7 }">
        <span>{{ index + 1 }}</span>
        <span class="person_name">{{ item.presentee }}</span>
        <span>
          <img
            src="../../../../../../common/images/recommend/sex_nan_select.png"
            v-if="!item.gender"
          />
          <img
            src="../../../../../../common/images/recommend/sex_nv_select.png"
            v-else
          />
        </span>
        <span>{{ item.contactNumber }}</span>

        <span>{{ forMatterTimes(item.createDate) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import personCard from "@/components/personCard";
export default {
  data() {
    return {};
  },
  props: {
    tabsActive: { type: Number, default: -2 },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: { type: Number, default: 0 },
    noDisposeTime: Number,
  },
  components: {
    "person-card": personCard,
  },

  methods: {
    forMatterTimes(data) {
      return data && data.split(" ")[0].replace(/[-]/g, "/");
    },
    toggle(e) {
      this.$router.push({
        name: "progressDetail",
        query: { id: e.id, type: e.type, status: this.item.status },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-card {
  display: flex;
  flex-direction: column;
  position: relative;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 99px;
    padding-right: 20px;
    font-size: 36px;
    width: 100%;

    .df {
      width: 168px;
      height: 48px;
      border-radius: 25px;
      border: 1px solid #ffffff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;

      font-size: 28px;
      font-weight: 500;
    }
    .back_btn {
      width: 100px;
      height: 99px;
      font-weight: 500;
      display: inline-flex;
      align-items: center;
      padding: 10px;
    }
    .title {
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      padding-left: 60px;
    }
  }
  .search-btn {
    padding: 0px 30px 0px 30px;
    height: 72px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .wrap_main {
    flex: 1;
    overflow: scroll;
    height: 100%;

    .main {
      padding: 30px;
      box-sizing: border-box;
    }
    .nodata {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .list {
    margin-bottom: 30px;
    min-height: 120px;
    position: relative;
    &:nth-child(1) {
      margin-top: 20px;
    }
    .infor {
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(164, 164, 164, 0.4);
      border-radius: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #333333;
      line-height: 80px;
      height: 120px;
      font-weight: 500;

      padding: 0 30px;
      img {
        width: 60px !important;
        height: 66px !important;
        padding: 10px !important;
      }
    }
    .warn {
      font-size: 28px;

      font-weight: 500;
      color: #0d9869;
    }
    .overdue {
      position: absolute;
      top: 0;
      left: 60;
      width: 88px;
      height: 80px;
      z-index: 1;
    }
    .if_expired {
      background: #f7f7f7;
    }
    .person_name {
      max-width: 120px;

      overflow: hidden;

      text-overflow: ellipsis;

      white-space: nowrap;
    }
  }
}
</style>
